import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';

export const ACCESS_LEVELS = {
  front_desk: { label: 'Front Desk', perms: [] },
  clinical: { label: 'Clinical Staff', perms: ['clinical', 'analytics'] },
  office_manager: { label: 'Office Manager', perms: ['clinical', 'analytics', 'billing', 'settings'] },
};

export function can(user, perm) {
  if (!user) return false;
  if (user.role !== 'practice_staff') return true;
  if (perm === 'staff') return false;
  return (ACCESS_LEVELS[user.accessLevel] || ACCESS_LEVELS.front_desk).perms.includes(perm);
}

export const RequirePermission = ({ perm, children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  if (loading || !user || can(user, perm)) return children;
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-testid="no-access-page">
      <div className="bg-white rounded-xl shadow p-8 max-w-md text-center">
        <Lock className="w-10 h-10 text-gray-400 mx-auto mb-3" />
        <h1 className="text-xl font-bold text-gray-900 mb-2">You don't have access to this page</h1>
        <p className="text-gray-600 mb-6">Your staff account doesn't include this area. Ask your practice admin if you need access.</p>
        <Button onClick={() => navigate('/')} data-testid="no-access-back-btn">Back to dashboard</Button>
      </div>
    </div>
  );
};
